// A dropped connection — Chrome's QUIC (HTTP/3) errors, a phone moving between
// Wi-Fi and mobile data — rejects fetch with "Failed to fetch" / "Load failed".
// The reader used to show that raw message and stop. A second try almost always
// works (the browser falls back to a fresh connection), so network failures are
// retried; HTTP errors are real answers and are returned as they are.

const wait = (ms: number) => new Promise((done) => setTimeout(done, ms));

export async function fetchWithRetry(input: string, init?: RequestInit, attempts = 3): Promise<Response> {
  for (let attempt = 1; ; attempt += 1) {
    try {
      return await fetch(input, init);
    } catch (reason) {
      if ((reason as Error).name === "AbortError" || init?.signal?.aborted || attempt >= attempts) throw reason;
      await wait(400 * attempt);
    }
  }
}

/** True for a fetch that failed on the network rather than with an HTTP status. */
export function isNetworkError(reason: unknown) {
  return reason instanceof TypeError && /fetch|load failed|network/i.test(reason.message);
}
